module.exports = __webpack_public_path__ + "media/components/assets/icons/img_remove-4dd94128caecdcc7e36090fe4241d4c7.svg";